var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBell = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08124 18.5935C9.75411 19.4488 10.8112 20 11.9998 20C13.1885 20 14.2455 19.4488 14.9184 18.5935C12.981 18.856 11.0187 18.856 9.08124 18.5935Z",
    fill: "#1bb92c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3991 9.6V10.1633C17.3991 10.8393 17.592 11.5001 17.9536 12.0626L18.8395 13.4409C19.6487 14.6999 19.031 16.4111 17.6235 16.8092C13.9416 17.8507 10.058 17.8507 6.37609 16.8092C4.96864 16.4111 4.35086 14.6999 5.16009 13.4409L6.04604 12.0626C6.40758 11.5001 6.6005 10.8393 6.6005 10.1633V9.6C6.6005 6.5072 9.01785 4 11.9998 4C14.9818 4 17.3991 6.50721 17.3991 9.6Z",
    fill: "#1bb92c"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3539_2466",
    x1: 4.7998,
    y1: 4,
    x2: 20.7114,
    y2: 18.3204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EFF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#199E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3539_2466",
    x1: 4.7998,
    y1: 4,
    x2: 20.7114,
    y2: 18.3204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EFF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#199E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107300"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Bell.9beb884d.svg";
export { ForwardRef as ReactComponent };